// extracted by mini-css-extract-plugin
export default {"Wrapper":"GalleryEditor_Wrapper__iQvM3"};